import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

    render() {
        const supplierVerificationDetails = this.props.supplierVerificationDetails;
        const data = this.props.searchData;
        const totalCals = this.props.totalCals;

        const successTotal = supplierVerificationDetails.reduce((total, row) => row.status === 2 ? total + parseFloat(row.txnAmount) : total, 0);
        const pendingTotal = supplierVerificationDetails.reduce((total, row) => row.status === 1 ? total + parseFloat(row.txnAmount) : total, 0);
        const failedTotal = supplierVerificationDetails.reduce((total, row) => row.status !== 2 && row.status !== 1 ? total + parseFloat(row.txnAmount) : total, 0);

        return (
            <div align='left'>
                <h3><center><u>Supplier Payment Verification Report</u></center></h3>
                <div >&nbsp;</div>
                <Box minWidth={1150}>
                    <TableContainer>
                        <Table aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">TransactionID</TableCell>
                                    <TableCell align='left'>Farmer Code</TableCell>
                                    <TableCell align="left">InvoiceNumber</TableCell>
                                    <TableCell align="left">Beneficiary&nbsp;Bank Code</TableCell>
                                    <TableCell align="left">Beneficiary&nbsp;Branch Code</TableCell>
                                    <TableCell align="left">Beneficiary&nbsp;Acc No</TableCell>
                                    <TableCell align="left">Beneficiary&nbsp;Acc Name</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                    <TableCell align="left">Debit&nbsp;Bank Code</TableCell>
                                    <TableCell align="left">Debit&nbsp;Branch Code</TableCell>
                                    <TableCell align="left">Debit&nbsp;Acc No</TableCell>
                                    <TableCell align="left">Debit&nbsp;Acc Name</TableCell>
                                    <TableCell align="left">Document No</TableCell>
                                    <TableCell align="left">Posting&nbsp;Date</TableCell>
                                    <TableCell align="left">Status</TableCell>
                                    <TableCell align="left">Status&nbsp;Code</TableCell>
                                    <TableCell align="left">Status&nbsp;Description</TableCell>
                                    <TableCell align="left">Status&nbsp;Update Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {supplierVerificationDetails.map((row) => {
                                    const isSuccess = row.status === 2;
                                    const benBranchCode = row.benBranchCode.toString().padStart(3, '0');
                                    const debitBranchCode = row.debitBranchCode.toString().padStart(3, '0');
                                    return (
                                        <TableRow key={row.TransactionID}>
                                            <TableCell align="left">{row.transactionID}</TableCell>
                                            <TableCell align='left'>{row.farmerCode}</TableCell>
                                            <TableCell align="left">{row.invoiceNumber}</TableCell>
                                            <TableCell align="left">{row.benBankCode}</TableCell>
                                            <TableCell align="left">{benBranchCode}</TableCell>
                                            <TableCell align="left">{row.benAccNo}</TableCell>
                                            <TableCell align="left">{row.benAccName}</TableCell>
                                            <TableCell align="right">{parseFloat(row.txnAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="left">{row.debitBankCode}</TableCell>
                                            <TableCell align="left">{debitBranchCode}</TableCell>
                                            <TableCell align="left">{row.debitAccNo}</TableCell>
                                            <TableCell align="left">{row.debitAccName}</TableCell>
                                            <TableCell align="left">{row.sequenceNumber}</TableCell>
                                            <TableCell align="left">{moment(new Date(row.postingDate)).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell align="left">{row.status === 2 ? 'Success' : row.status === 1 ? 'Pending' : 'Failed'}</TableCell>
                                            <TableCell align="left">{row.statusCode === null ? '-' : row.statusCode}</TableCell>
                                            <TableCell align="left">{row.statusDescription === null ? '-' : row.statusDescription}</TableCell>
                                            <TableCell align="left">{row.statusUpdateDate === null ? '-' : moment(new Date(row.statusUpdateDate)).format('YYYY-MM-DD')}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell align="left"><b>Total</b></TableCell>
                                    <TableCell colSpan={6} />
                                    <TableCell align="right"><b>{parseFloat(totalCals.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell colSpan={9} />
                                </TableRow>
                                <br></br>
                                <TableRow>
                                    <TableCell align="left"><b>Success Total</b></TableCell>
                                    <TableCell align="right"><b>{successTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell colSpan={16} />
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left"><b>Pending Total</b></TableCell>
                                    <TableCell align="right"><b>{pendingTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell colSpan={16} />
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left"><b>Failed Total</b></TableCell>
                                    <TableCell align="right"><b>{failedTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                    <TableCell colSpan={16} />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
